import React from "react";
import { motion } from "framer-motion";
import {
  Factory,
  Building2,
  Cpu,
  HeartPulse,
  Truck,
  Sprout,
  Hotel,
  Hammer,
  ShoppingBag,
  Ship,
  Pill,
  Zap,
} from "lucide-react";
import { INDUSTRY } from "@/constants/testIds";

const industries = [
  { slug: "manufacturing", label: "Manufacturing", icon: Factory, span: "md:col-span-2" },
  { slug: "real-estate", label: "Real Estate & Infra", icon: Building2 },
  { slug: "technology", label: "Technology & SaaS", icon: Cpu },
  { slug: "healthcare", label: "Healthcare", icon: HeartPulse, span: "md:row-span-2" },
  { slug: "logistics", label: "Logistics", icon: Truck },
  { slug: "agri", label: "Agri & F&B", icon: Sprout },
  { slug: "hospitality", label: "Hospitality", icon: Hotel },
  { slug: "construction", label: "EPC & Construction", icon: Hammer },
  { slug: "retail", label: "Retail & Consumer", icon: ShoppingBag, span: "md:col-span-2" },
  { slug: "ports", label: "Ports & Maritime", icon: Ship },
  { slug: "pharma", label: "Pharma & Lifesciences", icon: Pill },
  { slug: "energy", label: "Energy & Renewables", icon: Zap },
];

export const Industries = () => {
  return (
    <section id="industries" className="relative py-24 lg:py-32 bg-[#0d2017]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <p className="text-overline text-brand-accent">Industries served</p>
            <h2 className="mt-4 font-serif text-white text-4xl md:text-5xl tracking-tight leading-tight">
              Sector fluency, from{" "}
              <span className="italic text-brand-accent">factory floor</span> to boardroom.
            </h2>
          </div>
          <p className="md:max-w-sm text-sm md:text-base text-white/60 leading-relaxed">
            We work across India&rsquo;s growth sectors — pairing financial structure with operating
            context that lenders and investors recognise.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[140px] md:auto-rows-[160px] gap-4">
          {industries.map((ind, i) => {
            const Icon = ind.icon;
            return (
              <motion.div
                key={ind.slug}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.04 }}
                className={`hover-lift group relative border border-brand-border bg-brand-surface rounded-md p-5 flex flex-col justify-between overflow-hidden ${
                  ind.span || ""
                }`}
                data-testid={INDUSTRY.card(ind.slug)}
              >
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                     style={{ background: "radial-gradient(80% 80% at 80% 20%, rgba(16,185,129,0.18), transparent 70%)" }} />
                <Icon className="relative w-6 h-6 text-brand-accent" />
                <div className="relative">
                  <p className="text-overline text-white/40">Sector</p>
                  <p className="font-serif text-white text-xl md:text-2xl tracking-tight mt-1">
                    {ind.label}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
